export const airlineLargeLogo: {
  [airline: string]: {
    url: string,
    small: string,
    name: string,
    width: number,
    height: number,
  }
} = {
  "VJ": {
    url: "/static/vietjet-large-1x.png",
    small: "/static/vietjet-40x40.png",
    name: "Vietjet Air",
    width: 132,
    height: 54,
  },
  "QH": {
    url: "/static/bamboo-airways-logo-large-1x.png",
    small: "/static/bamboo-40x40.png",
    name: "Bamboo Airways",
    width: 192,
    height: 49,
  },
  "VU": {
    url: "/static/vietravel-airline-large-logo-1x.png",
    small: "/static/vietravel-40x40.png",
    name: "Vietravel Airlines",
    width: 370,
    height: 46,
  },
  "VN": {
    url: "/static/vn-airline-large-1x.jpg",
    small: "/static/vietnam_airlines-40x40.png",
    name: "Vietnam Airlines",
    width: 300,
    height: 63,
  },
  "SQ": {
    url: "/static/images/1G/SQ.png",
    small: "/static/images/1G/SQ.png",
    name: "Singapore Airlines",
    width: 300,
    height: 300,
  },
  "TR": {
    url: "/static/scoot-logo.svg",
    small: "/static/scoot-logo.svg",
    name: "Scoot Airlines",
    width: 300,
    height: 300,
  },
  "JQ": {
    url: "/static/jetstart-airline-large-1x.png",
    small: "/static/jetstart-airline-small-1x.png",
    name: "Jetstar Airlines",
    width: 300,
    height: 300,
  },
  "BL": {
    url: "/static/pacific-logo-large-1x.jpg",
    small: "/static/pacific-40x40.png",
    name: "Pacific Airlines",
    width: 269,
    height: 74,
  }
}